/** The message key for each error the SSO callback hands back in `?error=`. */
const CALLBACK_ERROR_KEYS = new Map<string, string>([
    ['admin_consent_required', 'publicPages.login.errors.adminConsentRequired'],
    ['unauthorized_tenant', 'publicPages.login.errors.unauthorizedTenant'],
    ['invite_only', 'publicPages.login.errors.inviteOnly'],
    ['auth_failed', 'publicPages.login.errors.authFailed'],
    ['invalid_state', 'publicPages.login.errors.invalidState'],
    ['token_acquisition_failed', 'publicPages.login.errors.tokenAcquisitionFailed'],
    ['invalid_token', 'publicPages.login.errors.invalidToken'],
    ['callback_failed', 'publicPages.login.errors.callbackFailed'],
]);

export function callbackErrorKey(error: string): string {
    return CALLBACK_ERROR_KEYS.get(error) ?? 'publicPages.login.errors.unexpected';
}
